var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.2,282.08l65.8,65.8-65.8,65.8-21.35-21.34L422,361.15c-85.15-9.22-136.51-52-186.37-93.55C181.12,222.14,129.6,179.21,34,179.21V149c106.53,0,164.72,48.49,221,95.38,46.61,38.85,91,75.84,162.62,85.78l-26.76-26.75ZM285.13,242.9c39.83-31.14,79-53.8,132.53-61.14l-26.81,26.81,21.35,21.35,65.8-65.8-65.8-65.8-21.35,21.34,31.21,31.22c-68.71,7.48-115.36,36.84-155.53,68.24ZM34,332.79V363c89.3,0,145.69-35,193.32-72.73l-18.75-23.66C158.46,306.32,109.6,332.79,34,332.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switchIcon.125db9693430306994ab039463c03f5b.svg";
export { ForwardRef as ReactComponent };